/**
 * ERC Similar Designator and Power Validator Adapter for DRC System
 *
 * This validator checks for designators that are similar to power net names.
 *
 * Feature-gated via DrcEnabledCheckers.ErcSimilarLabelAndPowerValidator
 */
import { EditorModes, ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../../drc/types";
import { ElectricalPinType, fluxPinTypeToElectricalType } from "../pinTypes";
/**
 * Validator that checks for similar designator and power net names.
 */
export class ErcSimilarLabelAndPowerValidator {
    reviewType = ReviewType.DesignRuleCheckErcSimilarLabelAndPower;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = true;
    async checkForProblems(inputs) {
        const foundProblems = [];
        // Collect power net names (lowercase -> original names)
        const powerNetNames = {};
        for (const element of Object.values(inputs.elements)) {
            const terminals = element.part_version_data_cache?.terminals;
            if (!terminals)
                continue;
            for (const terminal of Object.values(terminals)) {
                const pinType = fluxPinTypeToElectricalType(terminal.type);
                if (pinType === ElectricalPinType.POWER_IN || pinType === ElectricalPinType.POWER_OUT) {
                    const netName = terminal.name ?? "";
                    if (netName) {
                        powerNetNames[netName.toLowerCase()] = netName;
                    }
                }
            }
        }
        // Check labels against power net names
        for (const [elementUid, element] of Object.entries(inputs.elements)) {
            const partName = element.part_version_data_cache?.name?.toLowerCase() ?? "";
            // Check if this is a label element by name pattern
            if (!partName.includes("label")) {
                continue;
            }
            const labelName = element.label ?? element.part_version_data_cache?.name ?? "";
            if (!labelName)
                continue;
            const lowerLabel = labelName.toLowerCase();
            const matchingPower = powerNetNames[lowerLabel];
            if (matchingPower && matchingPower !== labelName) {
                foundProblems.push({
                    problemTypeKey: this.problemTypeKey,
                    key: `${this.problemTypeKey}_${elementUid}`,
                    label: `Designator "${labelName}" is similar to power net "${matchingPower}"`,
                    affectedItems: [{ type: "element", uid: elementUid }],
                    affectedViews: [EditorModes.schematic],
                });
            }
        }
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems,
        };
    }
}
//# sourceMappingURL=ErcSimilarLabelAndPowerValidator.js.map